import { FC, useRef, useState } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { Question } from './Question/Question';
import type { AnswerAndQuestion } from './AnswerQuestionSection.utils';

import styles from './AnswerQuestionSection.module.scss';

type Props = {
	answerAndQuestions: AnswerAndQuestion[];
};

export const AnswerQuestionSection: FC<Props> = ({ answerAndQuestions }) => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	const [isExpanded, setIsExpanded] = useState(false);
	const sectionRef = useRef<HTMLElement>(null);
	const displayedQuestions = isExpanded ? answerAndQuestions : answerAndQuestions.slice(0, 5);
	const handleToggleAnswers = () => {
		if (isExpanded) {
			sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}

		setIsExpanded((prev) => !prev);
	};

	return (
		<section ref={sectionRef} className={styles.answerQuestionSectionSection}>
			<div className={styles.content}>
				<div className={styles.title}>{t('about-us-container.answers-and-questions')}</div>
				<div className={styles.questions}>
					{displayedQuestions.map((item, index) => (
						<Question
							key={item.question}
							isFirst={index === 0}
							question={item.question}
							answer={item.answer}
							node={item?.node}
						/>
					))}
					{answerAndQuestions.length > 5 && (
						<div className={styles.moreAnswers} onClick={handleToggleAnswers}>
							{t(
								isExpanded
									? 'about-us-container.hide-answers'
									: 'about-us-container.show-more-answers',
							)}
						</div>
					)}
				</div>
			</div>
		</section>
	);
};
